import axios from 'axios'
import { errorHandler } from '../exports/error_management'
import { StorageCache } from '../exports/dataStorage'
const storageKey = 'ams-order-template-key'

const api = async (method, path, params) => axios[method](path, params)
const state = {
    selectedTemplate: {},
    templates: [],
}

const mutations = {
    set_template(state, payload) {
        state.selectedTemplate = payload
    },
    set_templates(state, payload) {
        state.templates = payload
    },
}

const actions = {
    /**
     * Set the selected template for a new template
     */
    async create(context, payload) {
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
            const results = await api('post', `order-template`, payload)
            context.commit('set_template', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchById(context, template_id) {
        try {
            const results = await api('get', `order-template/${template_id}`)
            console.log("results",results)
            context.commit('set_template', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async fetchAll(context) {
        const storageCache = new StorageCache(storageKey)
        try {
            const { is_valid, value } = storageCache.getArray()
            if (!is_valid) {
                const results = await api('get', `order-template`)
                console.log("results.data", results.data)
                const data = results.data.success.data
                storageCache.set(data)
                value.splice(0)
                value.push(...data)
            }
            context.commit('set_templates', value)
        } catch (err) {
            errorHandler(err)
        }
    },

    // async fetchAll(context) {
    //     try {
    //         const results = await api('get', `order-template`)
    //         context.commit('set_templates', results.data.success.data)
    //     } catch (err) {
    //         errorHandler(err)
    //     }
    // },

    async update(context, payload) {
        console.log('update', payload)
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
            const results = await api(
                'put',
                `order-template/${payload.id}`,
                payload
            )
            context.commit('set_template', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async delete(context, template_id) {
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
            await api('delete', `order-template/${template_id}`)
            context.commit('set_template', null)
            // context.dispatch('fetchAll')
        } catch (err) {
            errorHandler(err)
        }
    },

    async createItem(context, { template_id, item ,is_secondary_order_type }) {
        try {
            const results = await api(
                'post',
                `order-template/${template_id}/items`,{item,is_secondary_order_type}
            )
            context.commit('set_template', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async updateItem(context, { template_id, item }) {
        try {
            const results = await api(
                'put',
                `order-template/${template_id}/items/${item.id}`,
                item
            )
            context.commit('set_template', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async updateItemOrder(context, payload) {
        console.log('update', payload)
        try {
             await api(
                'post',
                `order-template/update/display/order`,
                payload
            )
            // context.commit('set_template', results.data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },
    async deleteItem(context, { template_id, item_id }) {
        try {
            const results = await api(
                'delete',
                `order-template/${template_id}/items/${item_id}`
            )
            context.commit('set_template', results.data.success.data);
        } catch (err) {
            errorHandler(err)
        }
    },

    async uploadOrderTemplate(context, payload) {
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
            const result = await api('post', `order-template/upload-order-templates`, payload)
            let success = result.data.success;
            let { data } = success == undefined ? {} : success;
            if (!data) return result.data.success || result.data.error;
            console.log("uploadOrder data", data);

            /* const orders = [...state.items]
                    const idx = orders.findIndex(x => x.id === data.id)
                    orders.splice(idx === -1 ? orders.length : idx, 1, data) */
            //// commit('SET_ORDERS', orders)

            return result.data.success;
        } catch (err) {
            errorHandler(err)
        }
      },
      async uploadOrderTemplateDetails(context, payload) {
        const storageCache = new StorageCache(storageKey)
        try {
            storageCache.reset()
            const result = await api('post', `order-template/upload-order-template-details`, payload)
            let success = result.data.success;
            let { data } = success == undefined ? {} : success;
            if (!data) return result.data.success || result.data.error;
            console.log("uploadOrder data", data);

            /* const orders = [...state.items]
                    const idx = orders.findIndex(x => x.id === data.id)
                    orders.splice(idx === -1 ? orders.length : idx, 1, data) */
            //// commit('SET_ORDERS', orders)

            return result.data.success;
        } catch (err) {
            errorHandler(err)
        }
      },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
